import script from "./TipDefault.vue?vue&type=script&lang=ts&setup=true"
export * from "./TipDefault.vue?vue&type=script&lang=ts&setup=true"

import "./TipDefault.vue?vue&type=style&index=0&id=cc8d43e0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc8d43e0"]])

export default __exports__